import styled from "styled-components";

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const DepositText = styled.div`
  display: flex;
  align-items: center;
`;

export const Separator = styled.span`
  margin: 0 var(--fd-space-space-1);
`;
